/**
* Register controller
* @namespace gplans.authentication.controllers
*/
(function () {
  'use strict';RegisterController.$inject = ["$state", "$rootScope", "Authentication", "Snackbar"];

  angular.
  module('gplans.authentication.controllers').
  controller('RegisterController', RegisterController);

  RegisterController.$inject = ['$state', '$rootScope', 'Authentication', 'Snackbar'];

  /**
                                                                                       * @namespace RegisterController
                                                                                       */
  function RegisterController($state, $rootScope, Authentication, Snackbar) {
    var vm = this;

    vm.errors = {
      email: [],
      username: [],
      password: [] };


    vm.register = register;

    activate();

    /**
                 * @name activate
                 * @desc Actions to be performed when this controller is instantiated
                 * @memberOf gplans.authentication.controllers.RegisterController
                 */
    function activate() {
      $rootScope.loginPage = $state.current.loginPage;
      // If the user is authenticated, they should not be here.
      if (Authentication.isAuthenticated()) {
        $state.go('gplans.userConsole');
      }
    }

    /**
      * @name register
      * @desc Register a new user
      * @memberOf gplans.authentication.controllers.RegisterController
      */
    function register() {
      Authentication.register(vm.email, vm.password, vm.username).then(function (res) {

      }, function (err) {
        vm.errors = err.data;
      });
    }
  }
})();